import withThreadsHoc from "../../helpers/withThreadsHoc";
import BooleanPointWithText from "./BooleanPointWithText";

const BooleanPointWithThreads = withThreadsHoc(
  BooleanPointWithText,
  ({ text }) => text[0]
);

export default BooleanPointWithThreads;
